<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="baseMaterialesopmappingLogs">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="产品名称">
            <el-input v-model.trim="filter.materialName" clearable/>
          </vm-search>
          <vm-search label="特性名称">
            <el-input v-model.trim="filter.propertyName" clearable/>
          </vm-search>
          <vm-search label="映射名称">
            <el-input v-model.trim="filter.standardPropertyName" clearable/>
          </vm-search>
          <vm-search label="映射类型">
            <el-select v-model="filter.materialType" clearable>
              <el-option label="控制柜" :value="10"/>
              <el-option label="人机" :value="20"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="operateType" align="center" width="100" label="操作类型"/>
      <el-table-column prop="materialName" align="center" width="300" label="产品名称"/>
      <el-table-column prop="materialType" align="center" width="100" label="映射类型">
        <template slot-scope="scope">
          <span>
            {{constant.mappingMaterialType[scope.row.materialType]}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="propertyName" align="center" label="特性名称"/>
      <el-table-column prop="standardPropertyName" align="center" width="140" label="映射名称"/>
      <el-table-column prop="standardPropertyValue" align="center" width="80" label="默认值"/>
      <el-table-column prop="dataType" align="center" width="80" label="数据类型">
        <template slot-scope="scope">
          <el-tag>
            {{constant.dataType[scope.row.dataType]}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="valueType" align="center" width="80" label="选择类型">
        <template slot-scope="scope">
          <el-tag>
            {{constant.valueType[scope.row.valueType]}}
            <!--            {{scope.row.dataType === 1004 && scope.row.valueType === 1 ? "是" : "否"}}-->
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="操作时间"/>
      <el-table-column prop="employeeName" align="center" label="操作人"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import PackageNoEdit from "@/views/information/SAPCustomerMaterialMapping/PackageNoEdit";
  import MaterialStandardMappingEdit from "@/views/information/MaterialStandardMapping/MaterialStandardMappingEdit.vue";

  export default {
    name: "MaterialStandardMappingLogList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        editAuth: this.$auth(498),
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          materialName: "",
          propertyName: "",
          standardPropertyName: "",
          materialType: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除行吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .delete("basic", "materialstandardmappings", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除行成功");
          });
        });
      },
      proDelete(row) {
        this.$confirm("确定删除产品吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .delete("basic", "materialstandardmappings/delProd", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除产品成功");
          });
        });
      },
      edit(row, isCopy) {
        this.$refs.editPage.open(row, isCopy);
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
            .exportFile("basic", "materialstandardmappings/export", this.filter)
            .then(res => {
              let blob = new Blob([res.data]);
              let fileName = decodeURI(res.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.exportLoading = false;
            })
            .catch(() => {
              this.exportLoading = false;
            });
      },

      //导入
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
